 /*
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * AdvertiserVerificationStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class AdvertiserVerificationStatus extends AbstractCrudObject {
  static get Fields (): Object {
    return Object.freeze({
      banner_type: 'banner_type',
      grace_period_ends_at: 'grace_period_ends_at',
      ufac_redirect_uri: 'ufac_redirect_uri',
      verification_status: 'verification_status',
    });
  }

}
